module.exports = __webpack_public_path__ + "static/media/sur_medio.70f87755.mp4";